import React from "react";

const FinishOnboardingStep = ({ step }) => {
    return (
        <div className="text-center">
            <h1
                className="fw-semibold mb-4"
                style={{
                    fontSize: "2.2rem",
                    color: "#222",
                    display: "flex",
                    justifyContent: "center",
                    alignItems: "center",
                    gap: "10px",
                }}
            >
                🎉 {step.step_title} 🎉
            </h1>

            <h4
                className="text-dark mb-4"
                style={{
                    fontSize: "1.4rem",
                    fontWeight: 400,
                    lineHeight: "1.6rem",
                }}
            >
                {step.step_description}
            </h4>
        </div>
    );
};

export default FinishOnboardingStep;